export const TOTALS_TABLE_HEADERS = [
  { id: 1, title: 'BDM', value: 'bdm', sortType: 'string' },
  { id: 2, title: 'Total Approved Hours', value: 'totalApprovedHours', sortType: 'numeric' },
  { id: 3, title: 'Approved Amount, $', value: 'approvedAmount', sortType: 'numeric' },
  { id: 4, title: 'Non-Approved Hours', value: 'nonApprovedHours', sortType: 'numeric' },
  { id: 5, title: 'Non-Approved Amount, $', value: 'nonApprovedAmount', sortType: 'numeric' },
];
